import { IScope } from "angular";
import { IGoal } from "../models";
import { GoalService } from "../goal.service";
import { UIErrorHandlingService } from "@gtmhub/error-handling";
import { IMetric } from "@gtmhub/okrs/metrics";
import { AnalyticsService } from "@gtmhub/core/analytics";
import { AccountResolverService } from "../../state/accountResolverService";

export interface ISubmitToMarketplaceScope extends IScope {
  goal: IGoal;
  goalFieldsToUpdate: {
    name: string;
    metricsFieldsToUpdate?: {
      [id: string]: {
        name: string;
      };
    };
  };

  includeSubmitter: boolean;
  success: boolean;
  indicators: {
    submitting: boolean;
    loading: boolean;
  };
  submit(): void;
  keyup(event, id: string): void;
  edit(id: string): void;
}

interface IStateParams {
  goalToBeSubmittedId: string;
}
export class SubmitToMarketplaceCtrl {
  public static $inject = ["$scope", "GoalService", "$stateParams", "UIErrorHandlingService", "AnalyticsService", "AccountResolverService"];

  constructor(
    private $scope: ISubmitToMarketplaceScope,
    private goalService: GoalService,
    private $stateParams: IStateParams,
    private uiErrorHandlingService: UIErrorHandlingService,
    private analyticsService: AnalyticsService,
    private accountResolverService: AccountResolverService
  ) {
    this.$scope.submit = this.submit;
    this.$scope.keyup = this.keyup;
    this.$scope.edit = this.edit;

    this.$scope.goalFieldsToUpdate = {
      name: "",
    };

    this.$scope.indicators = {
      submitting: false,
      loading: true,
    };

    this.$scope.includeSubmitter = true;

    this.init();
  }

  private init = () => {
    this.goalService.getGoal(this.$stateParams.goalToBeSubmittedId).then(
      (result: IGoal) => {
        this.$scope.goal = result;
        this.$scope.goalFieldsToUpdate.name = this.$scope.goal.name;

        if (this.$scope.goal.metrics) {
          this.$scope.goalFieldsToUpdate.metricsFieldsToUpdate = {};

          this.$scope.goal.metrics.forEach((metric: IMetric) => {
            this.$scope.goalFieldsToUpdate.metricsFieldsToUpdate[metric.id] = {
              name: metric.name,
            };
          });
        }

        this.$scope.indicators.loading = false;
      },
      (err) => this.uiErrorHandlingService.handleIndicator(err, { indicator: "loading", inline: false })
    );
  };

  private submit = () => {
    const data = {
      includeSubmitter: this.$scope.includeSubmitter,
      goalFieldsToUpdate: this.$scope.goalFieldsToUpdate,
    };

    this.$scope.indicators.submitting = true;
    this.goalService.submitToMarketplaceV2(this.$scope.goal.id, data).then(
      () => {
        const metaOkrTemplateSubmittedToMarketplace = {
          contributor: this.accountResolverService.getAccountData().name,
        };
        this.analyticsService.track("OKR template submitted to the Marketplace", metaOkrTemplateSubmittedToMarketplace);
        this.$scope.indicators.submitting = false;
        this.$scope.success = true;
      },
      (err) => this.uiErrorHandlingService.handleIndicator(err, { indicator: "submitting", inline: true })
    );
  };

  private keyup = (event, id: string): void => {
    if (event.key === "Enter") {
      document.getElementById(id).blur();
    }
  };

  private edit = (id: string): void => {
    document.getElementById(id).focus();
  };
}
